export const QUIZ_ROUTES = {
  list: '/quizzes',
  start: '/quizzes/start',
  selection: '/quizzes/selection',
  instruction: '/quizzes/instruction',
  detail: '/quizzes/detail',
  answerSheet: '/quizzes/answer-sheet',
  leaderboard: '/quizzes/leaderboard',
  resultAnalysis: '/quizzes/result-analysis',
  testSeriesList: '/quizzes/test-series',
};
